<template>
  <span v-html="svg" class="icon"></span>
</template>

<script>
  export default {
    props: ['name'],
    computed: {
      svg () {
        return require('@/icons/' + this.name + '.svg')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SvgIcon.vue